<div class="title-wrapper">
    <h1 class="header-txt">
        {{pageTitle}}
    </h1>
    <p class="sub-text"> 
        {{subPageTitle}}  
     </p> 
 </div> 